import React from 'react'
import Link from 'next/link'
import { Listing, Size, Condition, Color } from '@/api'
import { ListingItem } from '@/app/listings/components/Main/ListingItem'

interface SearchSuggestionsProps {
  suggestions: Listing[]
  searchKeyword: string
  buildSearchUrl: (keyword: string) => string
  onClose: () => void
  isMobile?: boolean
}

export const SearchSuggestions: React.FC<SearchSuggestionsProps> = ({
  suggestions,
  searchKeyword,
  buildSearchUrl,
  onClose,
  isMobile = false,
}) => {
  if (!suggestions.length) return null

  const containerClass = isMobile
    ? 'search-suggestions-container absolute top-full -left-8 -right-4 bg-white border border-gray-300 shadow-2xl z-50 max-h-[400px] overflow-y-auto'
    : 'search-suggestions-container absolute top-full right-0 mt-2 min-w-[280px] lg:min-w-[400px] w-max max-w-[95vw] lg:max-w-[500px] bg-white border border-gray-300 shadow-2xl z-50 max-h-[500px] overflow-y-auto'

  return (
    <div className={containerClass}>
      <div>
        {suggestions.map((listing) => (
          <div
            key={listing.id}
            className={`border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors duration-150 ${
              isMobile ? 'w-full' : ''
            }`}
          >
            <ListingItem
              key={listing.id}
              uuid={listing.uuid}
              title={listing.product?.productMaster?.name || ''}
              listingPrice={listing.price || 0}
              originalPrice={listing.product?.productMaster?.price || undefined}
              image={listing.images?.[0]}
              images={listing.images || undefined}
              size={listing.size as Size}
              condition={listing.condition as Condition}
              color={listing.product?.color as Color}
              horizontal={true}
              sex={listing.product?.productMaster?.sex}
              onClick={onClose}
            />
          </div>
        ))}
      </div>
      <Link
        href={buildSearchUrl(searchKeyword)}
        onClick={onClose}
        className="block px-4 py-3 text-center text-sm text-blue-600 hover:bg-blue-50 font-medium border-t border-gray-200 transition-colors duration-150"
      >
        すべて表示
      </Link>
    </div>
  )
}
